import { EventEmitter, Injectable } from '@angular/core';
import {ADMIN, AuthGuard, OPERATOR, SUPER_ADMIN, VIEWER} from '../common/auth-guard.service';
import { MenuItem } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class MenuService {

  public firstLevelChangeEmitter: EventEmitter<MenuItem>;

  private items: any[];

  constructor(private authGuard: AuthGuard) {
    this.firstLevelChangeEmitter = new EventEmitter<MenuItem>();
  }

  public getItems(): any[] {
    this.items = [];

    this.pushIfHasRole(VIEWER, {label: 'menu.home', icon: 'pi pi-home', description: 'menu.descriptions.home', routerLink: '/', routerLinkActiveOptions: {exact: true}});
    this.pushIfHasRole(VIEWER, {label: 'menu.map', icon: 'pi pi-map', description: 'menu.descriptions.map', routerLink: '/map'});
    this.pushIfHasRole(VIEWER, {label: 'menu.assets', icon: 'pi pi-map-marker', description: 'menu.descriptions.assets', routerLink: '/assets'});
    this.pushIfHasRole(VIEWER, {label: 'menu.devices', icon: 'pi pi-mobile', description: 'menu.descriptions.devices', routerLink: '/devices'});
    this.pushIfHasRole(VIEWER, {label: 'menu.kpis', icon: 'pi pi-chart-pie', description: 'menu.descriptions.kpis', routerLink: '/kpis'});
    this.pushIfHasRole(ADMIN, {label: 'menu.subscriptions', icon: 'pi pi-cloud-download', description: 'menu.descriptions.subscriptions', routerLink: '/subscriptions'});
    this.pushIfHasRole(OPERATOR, {label: 'menu.notifications', icon: 'pi pi-envelope', description: 'menu.descriptions.notifications', routerLink: '/notifications'});
    this.pushIfHasRole(VIEWER, {label: 'menu.shared', icon: 'pi pi-share-alt', description: 'menu.descriptions.shared', routerLink: '/shared'});
    this.pushIfHasRole(SUPER_ADMIN, {label: 'menu.applications', icon: 'pi pi-th-large', description: 'menu.descriptions.applications', routerLink: '/applications'});
    this.pushIfHasRole(ADMIN, {label: 'menu.sequences', icon: 'pi pi-hourglass', description: 'menu.descriptions.sequences', routerLink: '/sequences'});
    this.pushIfHasRole(OPERATOR, {label: 'menu.synoptics', icon: 'pi pi-box', description: 'menu.descriptions.synoptics', routerLink: '/synoptics'});

    this.pushIfHasRole(ADMIN, {label: 'menu.management', icon: 'pi pi-briefcase', routerLink: '/management', items: [
        {role: SUPER_ADMIN, label: 'menu.tenants', description: 'menu.descriptions.tenants', routerLink: '/management/tenants'},
        {label: 'menu.organizations', description: 'menu.descriptions.organizations', routerLink: '/management/organizations'},
        {label: 'menu.users', description: 'menu.descriptions.users', routerLink: '/management/users'}
      ]});

    this.pushIfHasRole(VIEWER, {label: 'menu.alarms', icon: 'pi pi-exclamation-triangle', routerLink: '/alarms', items: [
        {label: 'menu.triggers', description: 'menu.descriptions.triggers', routerLink: '/alarms/triggers'},
        {label: 'menu.triggerRules', description: 'menu.descriptions.triggerRules', routerLink: '/alarms/trigger-rules'},
        {label: 'menu.cepRules', description: 'menu.descriptions.cepRules', routerLink: '/alarms/cep-rules'}
    ]});

    this.pushIfHasRole(SUPER_ADMIN, {label: 'menu.monitoring', icon: 'pi pi-chart-bar', routerLink: '/monitoring', items: [
      {label: 'menu.statistics', description: 'menu.descriptions.statistics', routerLink: '/monitoring/statistics'},
      {label: 'menu.traceability', description: 'menu.descriptions.traceability', routerLink: '/monitoring/traceability'},
      {label: 'menu.nettopo', description: 'menu.descriptions.nettopo', routerLink: '/monitoring/network-topology'},
      {label: 'menu.audits', description: 'menu.descriptions.audits', routerLink: '/monitoring/audits'}
    ]});

    this.pushIfHasRole(VIEWER, {label: 'menu.system', icon: 'pi pi-cog', routerLink: '/system', items: [
        {label: 'menu.templates', description: 'menu.descriptions.templates', routerLink: '/system/templates'},
        {label: 'menu.assetRepresentations', description: 'menu.descriptions.assetRepresentations', routerLink: '/system/asset-representations'},
        {label: 'menu.deviceCategories', description: 'menu.descriptions.deviceCategories', routerLink: '/system/device-categories'},
        {label: 'menu.sensorTypes', description: 'menu.descriptions.sensorTypes', routerLink: '/system/sensor-types'},
        {label: 'menu.decoders', description: 'menu.descriptions.decoders', routerLink: '/system/decoders'},
        {label: 'menu.encoders', description: 'menu.descriptions.encoders', routerLink: '/system/encoders'},
        {label: 'menu.csvHistory', description: 'menu.descriptions.csvHistory', routerLink: '/system/csv-history'},
        {role: SUPER_ADMIN, label: 'menu.hwCatalog', description: 'menu.descriptions.hwCatalog', routerLink: '/system/hw-catalog'},
        {label: 'menu.devicesRemoved', description: 'menu.descriptions.devicesRemoved', routerLink: '/system/devices-removed'}
      ]});

    return this.items;
  }

  private pushIfHasRole(requiredRol: any , item: any): void {
    if (this.authGuard.hasRequiredRole(requiredRol) === true) {
      if (item.items) {
        const subItems = item.items;
        item.items = [];
        subItems.forEach(subItem => {
          if (subItem.role && this.authGuard.hasRequiredRole(subItem.role) === true) {
            item.items.push(subItem);
          } else if (!subItem.role) {
            item.items.push(subItem);
          }
        });
      }
      this.items.push(item);
    }
  }

}
